export function setThemeColor(color: string) {
  if (!document.head) {
    return
  }

  let el = document.head.querySelector('[name="theme-color"]')
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('name', 'theme-color')
    document.head.appendChild(el)
  }

  el.setAttribute('content', color)

  document.body.style.backgroundColor = color
}
